import { NavLink } from 'react-router-dom';

const MenuIcon = () => (
  <svg className="admin-sidebar__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="3" y="5" width="18" height="2" rx="1"/>
    <rect x="3" y="11" width="18" height="2" rx="1"/>
    <rect x="3" y="17" width="18" height="2" rx="1"/>
  </svg>
);

const PencilIcon = () => (
  <svg className="admin-sidebar__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
  </svg>
);

const CollapseIcon = ({ collapsed }) => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2">
    {collapsed ? (
      <polyline points="9 18 15 12 9 6"/>
    ) : (
      <polyline points="15 18 9 12 15 6"/>
    )}
  </svg>
);

export function AdminSidebar({ collapsed, onToggle }) {
  return (
    <aside className={`admin-sidebar${collapsed ? ' admin-sidebar--collapsed' : ''}`}>
      <NavLink to="/" className="admin-sidebar__logo" tabIndex={-1}>
        <div className="admin-sidebar__logo-mark">P</div>
        <span className="admin-sidebar__site-name">
          Kancelaria<br/>Radcy Prawnego
        </span>
      </NavLink>

      <nav className="admin-sidebar__nav">
        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          <li className="admin-sidebar__nav-item">
            <NavLink
              to="/admin/blogs"
              className={({ isActive }) =>
                `admin-sidebar__nav-link${isActive ? ' admin-sidebar__nav-link--active' : ''}`
              }
              title="Wpisy"
            >
              <MenuIcon />
              <span className="admin-sidebar__label">Wpisy</span>
            </NavLink>
          </li>
          <li className="admin-sidebar__nav-item">
            <NavLink
              to="/admin/blogs/new"
              className={({ isActive }) =>
                `admin-sidebar__nav-link${isActive ? ' admin-sidebar__nav-link--active' : ''}`
              }
              title="Nowy wpis"
            >
              <PencilIcon />
              <span className="admin-sidebar__label">Nowy wpis</span>
            </NavLink>
          </li>
        </ul>
      </nav>

      <button
        className="admin-sidebar__toggle"
        onClick={onToggle}
        title={collapsed ? 'Rozwiń menu' : 'Zwiń menu'}
        aria-label={collapsed ? 'Rozwiń menu' : 'Zwiń menu'}
      >
        <CollapseIcon collapsed={collapsed} />
      </button>
    </aside>
  );
}
